export default {"src":"/_next/static/media/visible.b9431fd5.svg","height":18,"width":23};